/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCellGroupProps } from './type';
const props: TdCellGroupProps = {
  /** 是否显示组边框 */
  bordered: {
    type: Boolean,
    value: false,
  },
  /** 单元格组风格 */
  theme: {
    type: String,
    value: 'default',
  },
  /** 单元格组标题 */
  title: {
    type: String,
    value: '',
  },
};

export default props;
